module.exports = __webpack_public_path__ + "img/Deactivate card.34618b12.svg";